<script setup lang="ts">
import { defineAsyncComponent } from 'vue'

const OrderListUnified = defineAsyncComponent(() => import('./OrderListUnified.vue'))
</script>

<template>
  <order-list-unified />
</template>
